import { useState, useEffect, useContext } from "react";
import DropDown from "../../Components/Shared/DropDown";
import { getExpMonthList, getExpYearList, getListOfStates } from "../../Services/MasterData";
import InputType from "../../Components/Shared/InputType";
import CryptoJS from "crypto-js";
import { sessionStorageKey } from "../../Config/Constants";
import {
  getTokenExID,
  getTokenExSecretKey,
  getTokenExScheme,
  kountVersion,
  kountMerchantId,
  KountTransactionSite,
  getKountKey,
  getPaypalHostUrl,
  getPaypalClientSecret,
  getPaypalClientId,
  getkountEnableOrNot,
} from "../../Util/PaymentConfig";
import {
  loadScript,
  readCookie,
  removeScript,
  setIPConfig,
  getPortalCD,
  getTenantId,
  createCookie,
} from "../../Util/helper";
import PaymentServiceAPI from "../../Services/PaymentServiceApi";
import { useNavigate } from "react-router-dom";
import PathHelper from "../../Util/PathHelper";
import { APP_NAVIGATION } from "../../Util/Constants";
import { defaultCountryCode, hidePaypal } from "../../Util/general-config";
import UserDataContext from "../../Contexts/User.context";
import ReactLoader from "../../Components/Shared/Loader/Loader";
import axios from "axios";

type Props = { callBack?: (p: {}) => void; paymentError?: string; doCheckOut: any; handleLoaderPopupHide: Function };

const CheckoutArticleBoxLeft = ({ callBack, paymentError, doCheckOut, handleLoaderPopupHide }: Props) => {
  const [ExpMonth, setExpMonth] = useState("");
  const [ExpYear, setExpYear] = useState("");
  const [fullName, setFullName] = useState("");
  const [stateVal, setStateVal] = useState("");
  const [skuGuidDetails, setSkuGuidDetails] = useState<any>();
  const expMonthList = getExpMonthList();
  const expYearList = getExpYearList();
  const stateList = getListOfStates();
  const queryParams = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  let pathRedirect = PathHelper(APP_NAVIGATION.PLAN);
  const RedirectPrivacyPath = PathHelper(APP_NAVIGATION.PRVCY);
  const RedirectTermsPath = PathHelper(APP_NAVIGATION.TERMS);
  const RedirectContactPath = PathHelper(APP_NAVIGATION.CONPG);
  const [allValues, setAllValues] = useState<any>();
  const [recurringPrice, setRecurringPrice] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const userGuid: any = !!readCookie("userguid") ? readCookie("userguid") : "";
  let isLoaded: any = !!readCookie("isLoaded") ? readCookie("isLoaded") : "false";
  //const [showLoader, setShowLoader] = useState("d-none");
  const nameOnCard = (e: { target: { value: any } }) => {
    const {
      target: { value },
    } = e;
    setFullName(value);
    let inputFileds = allValues?.val ? allValues.val : "";
    let val = {
      name: value,
      expmo: !!inputFileds.expmo ? inputFileds.expmo : "",
      expyr: !!inputFileds.expyr ? inputFileds.expyr : "",
    };
    setAllValues({ ...allValues, val });
    callBack?.(val);
  };
  const addExpMonthHandler = (e: { target: { value: any } }) => {
    const {
      target: { value },
    } = e;
    setExpMonth(value);
    let inputFileds = allValues?.val ? allValues.val : "";
    let val = {
      name: !!inputFileds.name ? inputFileds.name : "",
      expmo: value,
      expyr: !!inputFileds.expyr ? inputFileds.expyr : "",
    };
    setAllValues({ ...allValues, val });
    callBack?.(val);
  };
  const addEXpYearHandler = (e: { target: { value: any } }) => {
    const {
      target: { value },
    } = e;
    setExpYear(value);
    let inputFileds = allValues?.val ? allValues.val : "";
    let val = {
      name: !!inputFileds.name ? inputFileds.name : "",
      expmo: !!inputFileds.expmo ? inputFileds.expmo : "",
      expyr: value,
    };
    setAllValues({ ...allValues, val });
    callBack?.(val);
  };
  const addStateHandler = (e: { target: { value: any } }) => {
    const {
      target: { value },
    } = e;
    setStateVal(value);
  };
  const getUTCTimeStamp = () => {
    var date = new Date();
    return (
      date.getFullYear() +
      ("0" + (date.getUTCMonth() + 1)).slice(-2) +
      ("0" + date.getUTCDate()).slice(-2) +
      ("0" + date.getUTCHours()).slice(-2) +
      ("0" + date.getUTCMinutes()).slice(-2) +
      ("0" + date.getUTCSeconds()).slice(-2)
    );
  };
  const createHmac = () => {
    var concatinatedString =
      getTokenExID() + "|" + window.location.origin + "|" + getUTCTimeStamp() + "|" + getTokenExScheme();
    var hash = CryptoJS.HmacSHA256(concatinatedString, getTokenExSecretKey());
    var hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
    return hashInBase64;
  };
  const skuDetails = () => {
    let skuId = queryParams.get("s") || "";
    PaymentServiceAPI.getSkuDetails(skuId, "en").then((response: any) => {
      setRecurringPrice(response.currencySymbol + parseFloat(response.recurringPrice.toString()).toFixed(2));
      setUnitPrice(response.currencySymbol + parseFloat(response.unitPrice.toString()).toFixed(2));
      setSkuGuidDetails(response);
      if (isLoaded === "false") {
        createCookie("isLoaded", "true");
      }
    });
  };

  const {
    state: { email },
  } = useContext(UserDataContext);
  useEffect(() => {
    loadScript(process.env.PUBLIC_URL + "/static/tokenExScript.js");
    //setShowLoader("d-block");
    if (!!readCookie("jwtToken")) {
      skuDetails();
    } else {
      //navigate(!!locale ? setLocaleURL(ROUTE_CONSTANT.HOME_LOCALE, locale) : ROUTE_CONSTANT.HOME);
    }
    if (queryParams.has("pplrtrn") && queryParams.has("token")) {
      handleLoaderPopupHide("d-block");
      excecutePaypalProcess(queryParams.get("token"));
    }
    return () => {
      removeScript(process.env.PUBLIC_URL + "/static/tokenExScript.js");
    };
  }, []);

  function formatDateToIST(date: Date): string {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const dayOfMonth = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${month} ${dayOfMonth},${year}`;
  }
  const date = new Date();
  const formattedCurrentDate = formatDateToIST(date);
  const formattedPlusDate = formatDateToIST(new Date(date.setDate(date.getDate() + 14)));
  //PAYPAL IMPLEMENTATION
  const createPaypalAccessToken = () => {
    handleLoaderPopupHide("d-block");
    var axios = require("axios");
    var qs = require("qs");
    var data = qs.stringify({
      grant_type: "client_credentials",
    });
    var auth = "Basic " + btoa(getPaypalClientId() + ":" + getPaypalClientSecret());
    var config = {
      method: "post",
      url: getPaypalHostUrl() + "/v1/oauth2/token",
      headers: {
        Authorization: auth,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: data,
    };
    axios(config)
      .then(function (response: any) {
        if (!!response && !!response.data) {
          localStorage.setItem("ppat", response.data.access_token); //ppat=>PayPal Access Token
          createBillingAgreementToken(response.data.access_token);
        }
      })
      .catch(function (error: any) {
        console.log(error);
        handleLoaderPopupHide("d-none");
      });
  };
  const createBillingAgreementToken = (accessToken: any) => {
    let returnUrl = window.location.href + "&pplrtrn=true";
    let cancelUrl = window.location.href + "&cancel=true";

    var data = JSON.stringify({
      description: "LegalSimpli Subscription",
      payer: {
        payment_method: "Paypal",
        payer_info: {
          email: email,
        },
      },
      plan: {
        type: "MERCHANT_INITIATED_BILLING",
        merchant_preferences: {
          return_url: returnUrl,
          cancel_url: cancelUrl,
          accepted_pymt_type: "INSTANT",
          skip_shipping_address: true,
          immutable_shipping_address: true,
        },
      },
    });
    let access_token = "Bearer " + accessToken;
    var config = {
      method: "post",
      url: getPaypalHostUrl() + "/v1/billing-agreements/agreement-tokens",
      headers: {
        "Content-Type": "application/json",
        Authorization: access_token,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        localStorage.setItem("pptoken_id", response.data.token_id); //pp=>PayPal
        window.location = response.data.links[0].href;
        setTimeout(() => {
          handleLoaderPopupHide("d-none");
        }, 2000);
      })
      .catch(function (error) {
        console.log(error);
        handleLoaderPopupHide("d-none");
      });
  };
  const getUserAddressObject = () => {
    var userAddressObject = {
      userGuid: userGuid,
      city: setIPConfig("city"),
      state: setIPConfig("region"),
      country: setIPConfig("country"),
      zipCode: setIPConfig("zip"),
      addressType: 1,
      isActive: true,
      tenantId: getTenantId(),
    };
    return userAddressObject;
  };
  const excecutePaypalProcess = (token: any) => {
    handleLoaderPopupHide("d-block");
    let data = {
      firstName: email,
      lastName: "",
      email: email,
      paymentPortal: getPortalCD(),
      skuGuid: queryParams.get("s") || "",
      userGuid: userGuid,
      visitid: readCookie("visitGuid"),
      visitorid: readCookie("visitorGuid"),
      portalSource: getPortalCD(),
      customFields: customFieldsData,
      customerSource: "",
      paypalToken: token,
      ipAddress: setIPConfig("query"),
      ccDetails: null,
      users: null,
      userAddress: getUserAddressObject(),
    };
    doCheckOut(data);
  };
  const paypalHandler = () => {
    handleLoaderPopupHide("d-block");
    let acccessToken = createPaypalAccessToken();
  };
  let customFieldsData = {
    ipcountry: setIPConfig("countryCode", defaultCountryCode),
    protalsrc: getPortalCD(),
    localeval: "en",
  };
  //console.log("skuGuidDetails", skuGuidDetails);
  return (
    <>
      {/* <ReactLoader loaderProps={{ showloader: showLoader }} /> */}
      <input type="hidden" id="txOrigin" value={window.location.origin} />
      <input type="hidden" id="txID" value={getTokenExID()} />
      <input type="hidden" id="txTokenScheme" value={getTokenExScheme()} />
      <input type="hidden" id="hdnCardType" value="" />
      <input type="hidden" id="tokenExToken" value="" />
      <input type="hidden" id="hmac" value={createHmac()} />
      <input type="hidden" id="timeStamp" value={getUTCTimeStamp()} />
      <input type="hidden" id="cardNumberText" value={"CARD NUMBER"} />
      <input type="hidden" id="hdnOmniScore" value="" />
      <input type="hidden" id="hdnOutCome" value="" />
      <input type="hidden" id="hdnKountResponse" value="" />
      <input type="hidden" id="hdnipAddress" value={setIPConfig("query")} />
      <input type="hidden" id="hdnuserguid" value={userGuid} />
      <input type="hidden" id="hdnAmount" value={skuGuidDetails?.unitPrice} />
      <input type="hidden" id="hdnCurrency" value={skuGuidDetails?.currencyCD} />
      <input type="hidden" id="hdnbillingEmailAddress" value={email} />
      <input type="hidden" id="hdnproductType" value={skuGuidDetails?.scheduleTypeCD} />
      <input type="hidden" id="hdnproductDescription" value={skuGuidDetails?.description} />
      <input type="hidden" id="hdnplanAmount" value={skuGuidDetails?.recurringPrice} />
      <input type="hidden" id="hdnskuid" value={skuGuidDetails?.id} />
      <input type="hidden" id="hdnKountVersion" value={kountVersion} />
      <input type="hidden" id="hdnKountMerchantId" value={kountMerchantId} />
      <input type="hidden" id="hdnKountTransactionSite" value={KountTransactionSite} />
      <input type="hidden" id="hdnKountApiKey" value={getKountKey()} />
      <input type="hidden" id="hdnIskountEnable" value={getkountEnableOrNot()} />
      {/* <span className="paymentErrorMessage">{paymentError}</span> */}
      <div className="card_info payment-card-details">
        <h3 className="d-flex">
          <strong>Total Due Today</strong>{" "}
          <span className="d-flex">
            <span className="total-due-label">
              {skuGuidDetails?.scheduleTypeCD === "YEAR" ? recurringPrice : unitPrice}
            </span>
          </span>
        </h3>
        <div className="radio-buttons d-lg-none">
          <label className="custom-radio">
            <input id="rdVisa" type="radio" name="cccard" />
            <span className="radio-btn">
              <i className="fas fa-check"></i>
              <div className="card_icon">
                <img src={process.env.PUBLIC_URL + "/static/images/visa-icon-svg.svg"} alt="card" />
              </div>
            </span>
          </label>
          <label className="custom-radio">
            <input id="rdMasterCard" type="radio" name="cccard" />
            <span className="radio-btn">
              <i className="fas fa-check"></i>
              <div className="card_icon">
                <img src={process.env.PUBLIC_URL + "/static/images/mastercard-icon-svg.svg"} alt="card" />
              </div>
            </span>
          </label>
          <label className="custom-radio">
            <input id="rdAmex" type="radio" name="cccard" />
            <span className="radio-btn">
              <i className="fas fa-check"></i>
              <div className="card_icon">
                <img src={process.env.PUBLIC_URL + "/static/images/american-icon-svg.svg"} alt="card" />
              </div>
            </span>
          </label>
          <label className="custom-radio">
            <input id="rdDiscover" type="radio" name="cccard" />
            <span className="radio-btn">
              <i className="fas fa-check"></i>
              <div className="card_icon">
                <img src={process.env.PUBLIC_URL + "/static/images/discover-icon-svg.svg"} alt="card" />
              </div>
            </span>
          </label>
          <label className="custom-radio device-show">
            <input id="" type="radio" name="radio" />
            <span className="radio-btn">
              <i className="fas fa-check"></i>
              <div className="card_icon">
                <img src={process.env.PUBLIC_URL + "/static/images/all-card.png"} alt="card" />
              </div>
            </span>
          </label>
          <div id="authContentPlaceHolder_ucpaymentcontrol_paypalPanel" className="payment-options">
            <div
              id="authContentPlaceHolder_ucpaymentcontrol_paypalBtnLi"
              className="paypalBtnCC pay-options-mark paypalmark"
            >
              <input
                type="image"
                name="ctl00$authContentPlaceHolder$ucpaymentcontrol$PayViaPayalLnlButton"
                id="PayViaPayalLnlButton"
                className="clickable"
                data-toggle="modal"
                data-target="#paypal-loader-modal"
                src={process.env.PUBLIC_URL + "/static/images/pay-new.svg"}
              />
            </div>
          </div>
        </div>
        <div className="checkout-radio-group new-card">
          <div className="custom-control custom-radio btn-active">
            <input
              type="radio"
              id="customRadioInline1"
              name="customRadioInline1"
              className="custom-control-input"
              defaultChecked
            />
            <label className="custom-control-label" htmlFor="customRadioInline1">
              <img src={process.env.PUBLIC_URL + "/static/images/card-group-icon.png"} height="12" alt="card" />
            </label>
          </div>
          <div
            id="paypalRadio"
            className={
              hidePaypal(skuGuidDetails?.currencyCD) === false ? "custom-control custom-radio paypal-icon" : "d-none"
            }
          >
            <input
              type="radio"
              id="customRadioInline2"
              name="customRadioInline1"
              className="custom-control-input"
              data-toggle="modal"
              data-target="#paypal-loader-modal"
              onClick={paypalHandler}
            />
            <label className="custom-control-label" htmlFor="customRadioInline2">
              <img src={process.env.PUBLIC_URL + "/static/images/paypal-icon.svg"} height="15" alt="card" />
            </label>
          </div>
        </div>
        <div id="cardName" className="card_name">
          <label htmlFor="billing-card-name" className=" collapseitcc ">
            CARDHOLDER&apos;S NAME
          </label>
          <InputType
            inputProps={{
              id: "checkout_form_card_name",
              text: "CARDHOLDER'S NAME",
              type: "text",
              className: "form-control full-name nameoncard",
              index: 0,
              name: "billing-card-name",
              value: fullName || "",
            }}
            changeHandler={nameOnCard}
          />
          <span id="billing-card-name-flag" className="flagger red"></span>
          <span className="helper-text collapseitcc"></span>
        </div>
        <div className="date_area row align-items-start">
          <div className="card_number col-8 col-md-8" id="cardnumber">
            <label htmlFor="card-number" className=" collapseitcc">
              CARD NUMBER
            </label>
            <div className="input-group">
              <div id="tokenExIframeDiv" className="form-control collapseitcc security-field"></div>
              <span id="card-number-flag" className="flagger red"></span>
            </div>
          </div>

          <div className="card_date collapseitcc col-4 col-md-4" id="cvvDiv">
            <label htmlFor="billing-card-cvv" className=" collapseitcc">
              CVV
            </label>
            <div className="input-group" id="cvvTextBox">
              <div id="card-cvv-element" className="form-control collapseitcc security-field"></div>
              <span id="cvv-flag" className="flagger red"></span>
              <span className="cvv-card-icon"></span>
            </div>
          </div>
        </div>
        <div className="date_area row align-items-start">
          <div className="card_date collapseitcc col-8 col-md-8" id="expMonthDiv">
            <label htmlFor="billing-card-exp-month" className=" collapseitcc">
              Exp. Month
            </label>
            <DropDown
              inputProps={{
                id: "expmo",
                showLabel: true,
                selectedValue: ExpMonth || "",
                className: "form-select paymentbox ccMonthExp",
                index: 0,
                name: "ccMonthExp",
              }}
              options={expMonthList.data}
              changeHandler={addExpMonthHandler}
            />
            <span id="billing-card-exp-month-flag" className="flagger red hidden">
              Invalid Exp. Month
            </span>
          </div>
          <div className="card_date col-4 col-md-4" id="expYearDiv">
            <label htmlFor="billing-card-exp-year" className=" collapseitcc">
              Exp. Year
            </label>
            <DropDown
              inputProps={{
                id: "expyr",
                showLabel: true,
                selectedValue: ExpYear || "",
                className: "form-select paymentbox ccYearExp",
                index: 0,
                name: "ccYearExp",
              }}
              options={expYearList.data}
              changeHandler={addEXpYearHandler}
            />
            <span id="billing-card-exp-year-flag" className="flagger red hidden">
              Invalid Exp. Year
            </span>
          </div>
          <div className="card_date col-4 col-md-4 d-none" id="zipCodeDiv">
            <label htmlFor="billing-card-exp-year" className=" collapseitcc">
              Zip Code
            </label>
            <input
              name="ctl00$authContentPlaceHolder$ucpaymentcontrol$zipcode"
              type="text"
              id="zipcode"
              className="form-control zipcode"
              placeholder=""
            />
            <span id="billing-card-zip-code-flag" className="flagger red hidden">
              Invalid Zip Code
            </span>
          </div>
          <div className="card_date col-4 col-md-4 d-none" id="cityDiv">
            <label htmlFor="billing-card-city" className=" collapseitcc">
              City
            </label>

            <input
              name="ctl00$authContentPlaceHolder$ucpaymentcontrol$city"
              type="text"
              id="city"
              className="form-control full-name city"
              placeholder=""
            />
            <span id="billing-card-city-flag" className="flagger red hidden">
              Invalid City
            </span>
          </div>
          <div className="card_date collapseitcc col-4 col-md-4 d-none" id="stateDiv">
            <label htmlFor="billing-card-state" className=" collapseitcc">
              State
            </label>
            <DropDown
              inputProps={{
                id: "ddlState",
                showLabel: true,
                selectedValue: stateVal || "",
                className: "form-select paymentbox state",
                index: 0,
                name: "ddlState",
              }}
              options={stateList.data}
              changeHandler={addStateHandler}
            />
            <span id="billing-card-state-flag" className="flagger red hidden"></span>
          </div>
        </div>
        <div className="secure-section align-items-end">
          <span className="secure-disclaimer">
            <i className="fas fa-lock"></i>
            This is a secure 128-bit encrypted payment.
          </span>
          <span className="secure-logo ml-auto">
            <img src={process.env.PUBLIC_URL + "/static/images/norton-digicert-seal-logo.png"} alt="Norton Seal" />
          </span>
        </div>
        <div className="check_box">
          <span id="acceptCheckboxFlag" className="flagger red hidden">
            Don&apos;t forget this checkbox
          </span>
          <label className="form-check">
            <input type="checkbox" id="acceptCheckbox" />
            <span className="checkmark"></span>
            <span>
              <span className="abk">
                I accept the{" "}
                <a href={RedirectTermsPath.next} target="_blank">
                  Terms and Conditions
                </a>
                ,{" "}
                <a href="/refund-cancel" target="_blank">
                  Refund Policy{" "}
                </a>
                and{" "}
                <a href={RedirectPrivacyPath.next} target="_blank">
                  Privacy Policy
                </a>{" "}
                for LegalSimpli.
              </span>
              {skuGuidDetails?.scheduleTypeCD === "YEAR" ? "" : "Your access to LegalSimpli lasts for 14 days."}
              <span id="authContentPlaceHolder_ucpaymentcontrol_lblCancelAnytimeText">
                You can cancel anytime online,
              </span>
              <span id="authContentPlaceHolder_ucpaymentcontrol_trialWarningText">
                {" "}
                otherwise you&apos;ll pay just{" "}
                {!!skuGuidDetails?.unitPrice
                  ? skuGuidDetails?.currencySymbol + skuGuidDetails?.recurringPrice
                  : ""}{" "}
                {skuGuidDetails?.scheduleTypeCD === "YEAR" ? "per year" : "every 4 weeks"} starting on{" "}
                <strong> {skuGuidDetails?.scheduleTypeCD === "YEAR" ? formattedCurrentDate : formattedPlusDate}</strong>
                . For customer support, please call us at <strong> +1-855-235-3175 </strong> or e-mail
                support@legalsimpli.com.
              </span>
            </span>
          </label>
        </div>
      </div>
    </>
  );
};
export default CheckoutArticleBoxLeft;
